<template>
  <div class="container entry-new" ref="container" v-cloak>
    <!-- 顶部额度与进度 -->
    <div class="credit-header">
      <!-- 930 新表单按确认口径固定展示最高可借额度，不随填写进度递增。 -->
      <p class="credit-header-label">最高可借额度(元)</p>
      <p class="credit-header-amount">200000</p>
      <p class="credit-header-sub">具体审批额度以实际标准为准</p>
      <!-- 新版表单将息费提示紧跟左侧额度说明，并使用统一辅助文案色。 -->
      <div class="entry-annual-rate-notice">
        <span>年化利率(单利)：7.2%~24%(已包含全部息费)</span>
        <span>具体年化以最终授信及签约前明示表为准</span>
      </div>
      <div class="progress-bar-wrap">
        <div class="progress-bar-track">
          <div class="progress-bar-fill" :style="{ width: progressPercent + '%' }"></div>
        </div>
        <span class="progress-bar-text">{{ progressPercent }}%</span>
      </div>
    </div>

    <div class="register-form">
      <!-- 区块一：完善基础信息 -->
      <div class="section-card" :class="{ 'section-card--collapsed': !sectionExpand.basic }">
        <div class="section-card-header" @click="toggleSection('basic')">
          <span class="section-icon section-icon--basic">
            <van-icon name="contact" size="0.28rem" color="#fff" />
          </span>
          <p class="section-title">完善基础信息</p>
          <van-icon
            name="arrow-down"
            class="expand-arrow"
            :class="{ 'expand-arrow--open': sectionExpand.basic }"
            size="0.32rem"
            color="#999"
          />
        </div>

        <transition name="section-collapse">
          <div v-show="sectionExpand.basic" class="section-body">
            <!-- 芝麻信用分 -->
            <div class="field-row" ref="credit">
              <div class="field-row-header" @click="toggleFieldExpand('credit')">
                <span class="field-label">芝麻信用分</span>
                <div class="field-header-right">
                  <span v-if="form.credit && !fieldExpand.credit" class="field-value">{{
                    form.credit
                  }}</span>
                  <van-icon
                    name="arrow-down"
                    class="expand-arrow expand-arrow--sm"
                    :class="{ 'expand-arrow--open': fieldExpand.credit }"
                    size="0.28rem"
                    color="#999"
                  />
                </div>
              </div>
              <transition name="field-collapse">
                <div v-show="fieldExpand.credit" class="field-options tags">
                  <van-row :gutter="8">
                    <van-col
                      v-for="(item, index) in formItemData.credit"
                      :key="index"
                      :class="item.active ? 'active' : ''"
                      span="6"
                      @click="handleChooseCreditCredit(index, 'choose')"
                    >
                      <div class="option-chip">{{ item.dictLabel }}</div>
                    </van-col>
                  </van-row>
                </div>
              </transition>
            </div>

            <!-- 职业 -->
            <div class="field-row" ref="careerBox" v-if="showCareerField">
              <div class="field-row-header" @click="toggleFieldExpand('career')">
                <span class="field-label">职业</span>
                <div class="field-header-right">
                  <span v-if="form.occupation && !fieldExpand.career" class="field-value">{{
                    getCareerLabel()
                  }}</span>
                  <van-icon
                    name="arrow-down"
                    class="expand-arrow expand-arrow--sm"
                    :class="{ 'expand-arrow--open': fieldExpand.career }"
                    size="0.28rem"
                    color="#999"
                  />
                </div>
              </div>
              <transition name="field-collapse">
                <div v-show="fieldExpand.career" class="field-options tags">
                  <van-row :gutter="8">
                    <van-col
                      v-for="(item, index) in formItemData.career"
                      :key="index"
                      :class="item.active ? 'active' : ''"
                      span="6"
                      @click="handleChooseCareer(index, 'choose')"
                    >
                      <div class="option-chip">{{ item.dictLabel }}</div>
                    </van-col>
                  </van-row>
                </div>
              </transition>
            </div>

            <!-- 逾期情况 -->
            <div class="field-row" ref="creditInformation" v-if="showCreditInformationField">
              <div class="field-row-header" @click="toggleFieldExpand('creditInformation')">
                <span class="field-label">逾期情况</span>
                <div class="field-header-right">
                  <span
                    v-if="form.creditInformation && !fieldExpand.creditInformation"
                    class="field-value"
                    >{{ getCreditInformationLabel() }}</span
                  >
                  <van-icon
                    name="arrow-down"
                    class="expand-arrow expand-arrow--sm"
                    :class="{ 'expand-arrow--open': fieldExpand.creditInformation }"
                    size="0.28rem"
                    color="#999"
                  />
                </div>
              </div>
              <transition name="field-collapse">
                <div v-show="fieldExpand.creditInformation" class="field-options tags">
                  <van-row :gutter="8">
                    <van-col
                      v-for="(item, index) in formItemData.creditInformation"
                      :key="index"
                      :class="item.active ? 'active' : ''"
                      span="8"
                      @click="handleChooseCreditInformation(index, 'choose')"
                    >
                      <div class="option-chip">{{ item.dictLabel }}</div>
                    </van-col>
                  </van-row>
                </div>
              </transition>
            </div>
          </div>
        </transition>
      </div>

      <!-- 区块二：补充资产信息 -->
      <div
        v-if="showAssetSection"
        class="section-card"
        :class="{ 'section-card--collapsed': !sectionExpand.asset }"
      >
        <div class="section-card-header" @click="toggleSection('asset')">
          <span class="section-icon section-icon--asset"></span>
          <p class="section-title">补充资产信息</p>
          <van-icon
            name="arrow-down"
            class="expand-arrow"
            :class="{ 'expand-arrow--open': sectionExpand.asset }"
            size="0.32rem"
            color="#999"
          />
        </div>

        <transition name="section-collapse">
          <div v-show="sectionExpand.asset" class="section-body">
            <div v-for="field in visibleAssetFieldList" :key="field.key" class="field-row">
              <div class="field-row-header" @click="toggleFieldExpand(field.key)">
                <span class="field-label">{{ field.label }}</span>
                <div class="field-header-right">
                  <span
                    v-if="field.selected !== null && !fieldExpand[field.key]"
                    class="field-value"
                    >{{ getAssetFieldLabel(field) }}</span
                  >
                  <van-icon
                    name="arrow-down"
                    class="expand-arrow expand-arrow--sm"
                    :class="{ 'expand-arrow--open': fieldExpand[field.key] }"
                    size="0.28rem"
                    color="#999"
                  />
                </div>
              </div>
              <transition name="field-collapse">
                <div v-show="fieldExpand[field.key]" class="field-options tags binary-tags">
                  <van-row :gutter="12">
                    <van-col
                      v-for="opt in field.options"
                      :key="opt.value"
                      :class="field.selected === opt.value ? 'active' : ''"
                      span="12"
                      @click="handleSelectAssetField(field.key, opt.value)"
                    >
                      <div class="option-chip">{{ opt.label }}</div>
                    </van-col>
                  </van-row>
                </div>
              </transition>
              <!-- 车辆信息：sjh4 不展示，仅保留有车/无车选项 -->
              <transition name="field-collapse">
                <div
                  v-if="field.key === 'vehicle'"
                  class="car-box"
                  ref="carBox"
                  v-show="showCarInfoSection"
                >
                  <h4 class="car-box-title">车辆信息</h4>
                  <div class="car-info">
                    <div class="car-number">
                      <van-cell-group class="user_car_number">
                        <van-field
                          label="车牌号"
                          v-model.trim="form.plateNumber"
                          class="inp-elem car-number-line"
                          placeholder="请输入车牌号"
                          maxlength="20"
                          clearable
                          input-align="right"
                        />
                      </van-cell-group>
                    </div>
                    <div class="car-age">
                      <h4>车龄</h4>
                      <van-radio-group v-model="form.carAge" @change="handleCarAgeChange">
                        <van-row :gutter="16">
                          <van-col v-for="(item, index) in formItemData.carAge" :key="index">
                            <van-radio :name="item.dictValue" icon-size="16px" class="radio-item">
                              {{ item.dictLabel }}
                            </van-radio>
                          </van-col>
                        </van-row>
                      </van-radio-group>
                    </div>
                    <div class="car-purchase">
                      <h4>购车方式</h4>
                      <van-radio-group
                        v-model="form.carPurchaseMethod"
                        @change="handleCarPurchaseChange"
                      >
                        <van-row :gutter="16">
                          <van-col
                            v-for="(item, index) in formItemData.carPurchaseMethod"
                            :key="index"
                          >
                            <van-radio :name="item.dictValue" icon-size="16px" class="radio-item">
                              {{ item.dictLabel }}
                            </van-radio>
                          </van-col>
                        </van-row>
                      </van-radio-group>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
          </div>
        </transition>
      </div>

      <!-- 区块三：完成实名认证 -->
      <div
        v-if="showAuthSection"
        class="section-card"
        :class="{ 'section-card--collapsed': !sectionExpand.auth }"
      >
        <div class="section-card-header" @click="toggleSection('auth')">
          <span class="section-icon section-icon--auth"></span>
          <p class="section-title">完成实名认证</p>
          <van-icon
            name="arrow-down"
            class="expand-arrow"
            :class="{ 'expand-arrow--open': sectionExpand.auth }"
            size="0.32rem"
            color="#999"
          />
        </div>

        <transition name="section-collapse">
          <div v-show="sectionExpand.auth" class="section-body section-body--auth">
            <div class="auth-static-row" ref="realName">
              <span class="auth-static-label">真实姓名</span>
              <van-field
                class="auth-static-field"
                v-model.trim="form.realName"
                placeholder="请输入姓名"
                maxlength="20"
                @blur="handleBlur(0)"
                clearable
                input-align="right"
                :border="false"
                :disabled="isEditIdCard"
              />
            </div>

            <div class="auth-static-row" ref="idCard">
              <span class="auth-static-label">身份证</span>
              <van-field
                class="auth-static-field"
                v-model.trim="form.idCard"
                placeholder="请输入身份证号"
                maxlength="18"
                @blur="handleBlur(1)"
                clearable
                input-align="right"
                :border="false"
                :disabled="isEditIdCard"
              />
            </div>

            <div class="auth-city-block" ref="cityBox">
              <div class="auth-static-row auth-static-row--city" @click="handleClickPosition">
                <span class="auth-static-label">所在城市</span>
                <div class="auth-city-picker">
                  <img
                    class="city-icon"
                    src="../../assets/images/image_orange/entry/icon_position.png"
                    alt=""
                  />
                  <span class="city-text">{{ addressPositionName || '请选择城市' }}</span>
                  <van-icon name="arrow-down" size="0.28rem" color="#999" />
                </div>
              </div>
              <p class="city-hint">请填写长期居住城市，否则有下款失败可能</p>
            </div>
          </div>
        </transition>
      </div>
    </div>

    <div class="fixed-btn">
      <!-- 协议 -->
      <van-checkbox
        v-model="checked"
        @input="handleTl5ThemeOneAgreementChange"
        checked-color="#ff5612"
        icon-size="0.3rem"
        class="protocols u-flex u-col-top"
        :class="{ 'protocols--930': flowMode === '930' }"
      >
        我已阅读并同意
        <!-- 930 仅调整协议展示名称，原协议内容和点击逻辑保持不变。 -->
        <small @click.stop="showProp('xxsq')" class="protocols-title">
          {{ flowMode === '930' ? '《个人信息处理授权协议》' : '《个人信息共享授权书》' }}</small
        >
        <small @click.stop="showProp('zqgz')" class="protocols-title">
          {{ flowMode === '930' ? '《敏感信息处理授权协议》' : '《知情告知书》' }}
        </small>
      </van-checkbox>
      <!-- 提交按钮仅区分展示文案，930 与旧表单继续复用各自原有提交逻辑。 -->
      <div class="btn-con">
        <van-button
          class="btn"
          :class="{ 'btn--disabled': !isSubmitEnabled }"
          type="default"
          @click="handleSubmit"
          :loading="loading"
          loading-type="spinner"
        >
          {{ flowMode === '930' ? '立即申请' : '确认额度' }}
        </van-button>
        <!-- <small class="pa btn-tips">新用户立享30天免息券*2</small> -->
      </div>
    </div>

    <!-- 定位城市下拉选 -->
    <van-popup v-model="showPickerCity" position="bottom" safe-area-inset-bottom round>
      <van-picker
        show-toolbar
        :columns="areaList"
        @change="onCityChange"
        @confirm="handleEntrySjhCityConfirm"
        @cancel="showPickerCity = false"
        value-key="localName"
      >
        <div slot="title" class="picker-title u-text-center">
          <p>请选择定位城市</p>
          <p class="pa">准确的贷款申请城市将决定我们是否能为您提供贷款服务，请按您所在地如实填写</p>
        </div>
      </van-picker>
    </van-popup>

    <Agreement
      @handleGoOn="handleGoOn"
      @popupOpened="handleTl5ThemeOneAgreementPopupOpened"
      @knowClicked="handleTl5ThemeOneAgreementKnowClicked"
      :incomingShow.sync="incomingShow"
      :sendData="sendData"
      :protocolDynamicData="protocolDynamicData"
      :form="form"
      :applyTime="applyTime"
      :companys="companys"
      :companyAlias="companyAlias"
      :productId="productId"
      :applyId="applyId"
    />
    <!-- 当前页面推贷超产品弹窗 -->
    <ProductsPop :productsPopShow="showProductsPop" :productsPopData="productsPopData" />
    <!-- 《个人信息共享授权书》和《知情告知书》局部弹窗 -->
    <van-popup
      v-model="showProtocol"
      round
      :style="{
        width: '80%',
        height: '70%',
      }"
      @close="handleClose"
    >
      <div class="show-protocol-con">
        <h4 class="u-text-center">{{ loaclTitle }}</h4>
        <div class="show-protocol-info protocol-content" v-html="showContent" />
        <div class="show-protocol-btn u-text-center" @click="showProtocol = false">关闭</div>
      </div>
    </van-popup>

    <!-- 返回拦截挽留弹窗（仅拦截一次） -->
    <van-overlay :show="showBackInterceptPop" :lock-scroll="true" z-index="999">
      <div class="back-intercept-wrap u-flex u-row-center u-col-center">
        <div class="back-intercept-pop">
          <van-icon
            class="back-intercept-close"
            name="cross"
            size="0.45rem"
            @click="handleBackInterceptClose"
          />
          <!-- 返回挽留弹窗仅保留额度事实与继续填写入口，避免资格及激活暗示。 -->
          <h3 class="back-intercept-title">最高可借20万</h3>
          <div class="back-intercept-body">
            <ul class="back-intercept-list">
              <!-- 合规调整：移除限时审核和最低利率承诺。 -->
              <li>
                <span class="back-intercept-check"></span>
                按日计息，还款灵活
              </li>
            </ul>
          </div>
          <p class="back-intercept-tips">*信息仅用于额度评估，资料将被加密保护</p>
          <div class="back-intercept-btn" @click="handleBackInterceptContinue">继续填写</div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>
<script>
import { setEncryption } from '@/utils/encrypt' //引入加密文件
import * as API_Common from '@/api/common.js'
import ProductsPop from '@/components/productsPop/index'
import Agreement from '@/components/Agreement'
import { entryCommon } from '@/mixins/entryCommon.js'
import formPageBuriedMixin from '@/mixins/formPageBuriedMixin.js'
import { mapPosition } from '@/mixins/mapPosition.js'
// import { getCookie, setCookie } from "@/utils/cookies.js";
import { setCookie } from '@/utils/cookies.js'
import { replaceTemplateValues } from '@/utils/replaceTemplateValues.js'
import { RUNTIME_ENV } from '@/utils/runtimeEnv.js'
import { validateChinesePlateNumber, PLATE_NUMBER_FORMAT_ERROR_MSG } from '@/utils/plateNumber.js'
export default {
  name: 'entryNew',
  mixins: [entryCommon, mapPosition, formPageBuriedMixin],
  props: {
    flowMode: {
      type: String,
      default: 'legacy',
    },
  },
  data() {
    return {
      positionStatus: false, // 定位是否成功，默认false
      positionCityStatus: false, // 百度定位中是否包含城市信息(如果不包含也相当于定位失败)
      provinceArr: undefined, // 百度定位中是否包含城市信息(如果不包含也相当于定位失败)-集合中是对应省的一条数据
      checked: false, // 协议勾选
      address: {
        // 定位地址
        province: '', // 省
        city: '', // 市
      },
      areaList: [
        // 自定义省数据二级结构
        { values: [] },
        { values: [] },
      ],
      showPickerCity: false, // 省市联动弹窗状态
      form: {
        // 提交表单
        channelNo: this.$route.query.source, // 渠道标识
        loanAmount: this.$route.query.amount || 100000, // 借款金额
        loanPurpose: this.$route.query.purpose, // 借款用途
        loanPeriod: this.$route.query.period
          ? parseInt(this.$route.query.period) === 9
            ? 12
            : this.$route.query.period
          : 6, // 借款期限(宜享花传入的期限可能为9期，为了兼容咱们自己的借款期限(目前支持3 6 12 24)的情况如果宜享花传入的期数为9强制修改为12期 )
        realName: '', // 姓名
        idCard: '', // 身份证号码
        credit: '', // 芝麻分
        assets: [], // 个人资产
        gpsCityName: '', // 省市展示名称
        cityId: '', // 城市ID
        provinceId: '', // 省ID
        creditInformation: '', // 逾期情况
        occupation: '', // 职业
        isCar: 0,
        showCarInfo: 1,
        plateNumber: '', // 车牌号
        carAge: '', // 车龄
        carPurchaseMethod: '', // 购车方式
      },
      formItemData: {
        credit: [
          // 芝麻分集合
          { dictValue: '700以上', dictLabel: '700以上', active: false },
          { dictValue: '650-700', dictLabel: '650-700', active: false },
          { dictValue: '600-650', dictLabel: '600-650', active: false },
          { dictValue: '600以下', dictLabel: '600以下', active: false },
        ],
        career: [
          // 职业集合
          { dictValue: 1, dictLabel: '上班族' },
          { dictValue: 2, dictLabel: '自由职业' },
          { dictValue: 3, dictLabel: '私营企业主' },
          { dictValue: 4, dictLabel: '公务员/国企' },
        ],
        creditType: [
          // 与 entry_sjh 一致，提交时按 active 构建 assets（UI 不展示，由 assetFieldList 同步）
          { dictValue: 3, dictLabel: '有公积金', active: false },
          { dictValue: 1, dictLabel: '有房', active: false },
          { dictValue: 2, dictLabel: '有车', active: false },
          { dictValue: 4, dictLabel: '有社保', active: false },
          { dictValue: 5, dictLabel: '有商业保险', active: false },
          { dictValue: 6, dictLabel: '企业主', active: false },
        ],
        creditInformation: [
          // 逾期情况
          { dictValue: 1, dictLabel: '征信良好' },
          { dictValue: 2, dictLabel: '无人行征信' },
          { dictValue: 3, dictLabel: '有逾期' },
        ],
        carAge: [
          // 车龄集合
          { dictValue: 1, dictLabel: '0-5年' },
          { dictValue: 2, dictLabel: '5-10年' },
          { dictValue: 3, dictLabel: '10年以上' },
        ],
        carPurchaseMethod: [
          // 购车方式集合
          { dictValue: 1, dictLabel: '全款' },
          { dictValue: 2, dictLabel: '分期-已结清' },
          { dictValue: 3, dictLabel: '分期-未结清' },
        ],
      },
      regTest: {
        // 正则校验
        regIdcard:
          /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/, // 身份证号码正则校验
        regName: /^[\u4e00-\u9fa5]{2,10}[·.]*$/, // 姓名2-10位中文正则校验
      },
      xxsq: '', // 个人信息共享授权书
      // xxsqHeightFlag: true, // 个人信息共享授权书局部内容是否展开状态
      zqgz: '', // 知情告知书
      // zqgzHeightFlag: true, // 知情告知书局部内容是否展开状态
      showContent: '', //  // 个人信息共享授权书 和 知情告知书 局部弹窗详细内容
      showProtocol: false, // 个人信息共享授权书 和 知情告知书 局部弹窗隐藏显示
      // tdgrxx: "", //特定机构个人信息授权
      // tdgrxxHeightFlag: true, //特定机构个人信息授权是否展开状态
      // tdyszc: "", //特定机构知情告知书
      // tdyszcHeightFlag: true, // 特定机构知情告知书是否展开状态
      tdArea: '', // 特定机构的地理位置信息
      isSpecificInstitution: false, //是否需要展示特定机构的协议
      companys: '', // 公司名称集合
      companyAlias: '', // 公司别名
      loaclTitle: '', // 局部协议弹窗顶部title,
      brand: this.$route.query.brand, // 设备型号
      downPageUrl: this.$route.query.downPageUrl, // 进件结果下载页地址
      applyId: '', // 进件申请ID
      applyTime: '', // 进件申请时间
      hasPushSuccess: undefined, // 是否推送成功
      loanSuperPageRedirectRule: undefined, // 贷超页面跳转规则
      jwt: this.$route.query.jwt, // 登录字符串
      env: RUNTIME_ENV, // 业务环境，见 @/utils/runtimeEnv.js
      loading: false, //确认额度按钮点击状态
      isRedirectProductsPage: parseInt(this.$route.query.isRedirectProductsPage), // 标识是否是贷超流程的字段1是 0否
      isRedirectWorkWeixinPage: parseInt(this.$route.query.isRedirectWorkWeixinPage), // 标识如果不是贷超流程需要用此字段进行判断是否跳转引导企业微信页面中，引导用户用企业微信扫码联系客服1是 0否
      workWeixinUrl: this.$route.query.workWeixinUrl, // 跳转微信地址url
      isTail: undefined, // 是否是兜底 1-是 0-否
      redirectUrl: '', // 重定向链接
      productId: null, // 产品id
      sendData: null,
      apiReqType: null, //接口请求类型, 1-闪借花、2-吉琼宝
      jqbApplyId: null, //吉琼包申请ID
      jqbProductId: null, //jqbProductId
      isShowTenAccount: this.$route.query.isShowTenAccount,
      isEditIdCard: false, // 是否可以编辑身份证号和姓名
      hasEchoedProfile: false, // 接口回显老用户资料（展示/计算用，与 isEditIdCard 可并存）
      isShowNewTips: false, // 根据渠道判断是否不展示中国香港
      protocolDynamicData: {
        // 协议动态值
        idCard: '',
        realName: '',
        mobile: '',
        uid: '',
      },
      showProductsPop: false, // 当前页面推产品展示弹窗
      productsPopData: [], // 当前页面推产品展示弹窗数据
      showBackInterceptPop: false, // 返回拦截挽留弹窗
      backInterceptUsed: false, // 是否已展示过返回拦截（仅拦截一次）
      // 仅用户在本页操作过的项才计入进度（接口回显不计入）
      progressCountedFields: {
        credit: false,
        occupation: false,
        creditInformation: false,
        socialSecurity: false,
        providentFund: false,
        vehicle: false,
        room: false,
        businessInsurance: false,
        realName: false,
        idCard: false,
        city: false,
      },
      sectionExpand: {
        basic: true,
        asset: false,
        auth: false,
      },
      sectionExpandAutoSync: true, // 进页自动同步折叠态；用户手动点击后不再自动改
      fieldExpand: {
        credit: true,
        career: false,
        creditInformation: false,
        socialSecurity: false,
        providentFund: false,
        vehicle: false,
        room: false,
        businessInsurance: false,
      },
      assetFieldList: [
        {
          key: 'socialSecurity',
          dictValue: 4,
          label: '社保缴纳',
          options: [
            { value: 0, label: '无社保' },
            { value: 1, label: '有社保' },
          ],
          selected: null,
        },
        {
          key: 'providentFund',
          dictValue: 3,
          label: '公积金缴纳',
          options: [
            { value: 0, label: '无公积金' },
            { value: 1, label: '有公积金' },
          ],
          selected: null,
        },
        {
          key: 'vehicle',
          dictValue: 2,
          label: '车产情况',
          options: [
            { value: 0, label: '无车' },
            { value: 1, label: '有车' },
          ],
          selected: null,
        },
        {
          key: 'room',
          dictValue: 1,
          label: '房产情况',
          options: [
            { value: 0, label: '无房' },
            { value: 1, label: '有房' },
          ],
          selected: null,
        },
        {
          key: 'businessInsurance',
          dictValue: 5,
          label: '保险保单',
          options: [
            { value: 0, label: '无保单' },
            { value: 1, label: '有保单' },
          ],
          selected: null,
        },
      ],
    }
  },
  components: {
    ProductsPop,
    Agreement,
  },
  created() {
    window.__TRACK_SCENE_KEY__ = 'entrySjh'
    this.initBackInterceptListener()
    if (this.$route.query.source == 'sjhjd') {
      this.clearPageFavicon()
    }
  },
  computed: {
    /** 编辑/回显态：三块全展开、字段全展示、额度进度按已有数据计算 */
    isFormReviewMode() {
      return this.isEditIdCard || this.hasEchoedProfile
    },
    hasSelectedCar() {
      const vehicleField = this.assetFieldList.find((f) => f.key === 'vehicle')
      return vehicleField && vehicleField.selected === 1
    },
    showCarInfoSection() {
      // sjh4 仅收集是否有车，不展示车牌/车龄等车辆信息
      return false
    },
    addressPositionName() {
      if (this.positionStatus) {
        return `${this.address.province} ${this.address.city}`
      }
      if (this.form.gpsCityName) {
        return this.form.gpsCityName
      }
      return ''
    },
    hasValidCity() {
      return this.positionStatus || this.form.cityId !== ''
    },
    isNameValid() {
      const text = this.form.realName
      if (!text) return false
      if (!/^[\u4e00-\u9fa5·.]+$/.test(text)) return false
      const chineseOnly = text.replace(/[·.]/g, '')
      return chineseOnly.length >= 2 && chineseOnly.length <= 10
    },
    isIdCardValid() {
      return !!(this.form.idCard && this.regTest.regIdcard.test(this.form.idCard))
    },
    allAssetFieldsSelected() {
      return this.assetFieldList.every((f) => f.selected !== null)
    },
    showCareerField() {
      return this.isFormReviewMode || !!this.form.credit
    },
    showCreditInformationField() {
      return this.isFormReviewMode || !!this.form.occupation
    },
    showAssetSection() {
      return this.isFormReviewMode || this.isBasicInfoComplete()
    },
    visibleAssetFieldList() {
      if (this.isFormReviewMode) return this.assetFieldList
      if (!this.showAssetSection) return []
      const visible = []
      for (let i = 0; i < this.assetFieldList.length; i++) {
        const field = this.assetFieldList[i]
        if (i === 0) {
          visible.push(field)
          continue
        }
        const prev = this.assetFieldList[i - 1]
        if (this.isAssetFieldProgressComplete(prev)) {
          visible.push(field)
        } else {
          break
        }
      }
      return visible
    },
    showAuthSection() {
      if (this.isFormReviewMode) return true
      return this.isBasicInfoComplete() && this.isAssetInfoComplete() && this.isCarInfoComplete()
    },
    progressPercent() {
      let p = 55 // 初始进度 55%
      if (this.progressCountedFields.credit && this.form.credit) p += 3
      if (this.progressCountedFields.occupation && this.form.occupation) p += 3
      if (this.progressCountedFields.creditInformation && this.form.creditInformation) p += 3
      p += this.calcAssetProgressPercent()
      if (this.progressCountedFields.realName && this.isNameValid) p += 5
      if (this.progressCountedFields.idCard && this.isIdCardValid) p += 6
      if (this.progressCountedFields.city && this.hasValidCity) p += 3
      return Math.min(p, 100)
    },
    isSubmitEnabled() {
      const basicValid =
        this.isNameValid &&
        this.isIdCardValid &&
        this.form.credit &&
        this.form.occupation &&
        this.form.creditInformation &&
        this.allAssetFieldsSelected &&
        this.hasValidCity &&
        this.checked

      if (!basicValid) return false

      if (this.showCarInfoSection) {
        return (
          this.form.plateNumber &&
          validateChinesePlateNumber(this.form.plateNumber) &&
          this.form.carAge &&
          this.form.carPurchaseMethod
        )
      }
      return true
    },
  },
  beforeRouteLeave(to, from, next) {
    if (!this.isBackInterceptEnabled()) {
      next()
      return
    }
    if (this.showBackInterceptPop) {
      next(false)
      return
    }
    this.openBackInterceptPop()
    next(false)
  },
  mounted() {
    this.getCityLocation() // 通过ip获取定位
    this.getUserDetail() // 用户回显信息
    this.getProtocol() // 获取个人信息共享授权书 和 知情告知书 协议内容

    // vuex中存储登录状态
    this.$nextTick(() => {
      this.$store.dispatch('setJwt', this.jwt)
    })
    setCookie('token', this.jwt) // 直接拿jwt替换本地token-20250416修改逻辑
    // let cookies = getCookie("token");
    // if (!cookies || cookies === "") {
    //   setCookie("token", this.jwt);
    // }
    // if (
    //   this.$route.query.linkFromPage &&
    //   this.$route.query.linkFromPage === "wechat_miniprogram"
    // ) {
    //   setCookie("token", this.jwt);
    // }

    // 根据不同渠道展示不同文案
    if (
      this.$route.query.source == 'tongcheng01' ||
      this.$route.query.source == 'wwwooo22' ||
      this.$route.query.source == 'wwwooo03' ||
      this.$route.query.source == 'wwwooo04'
    ) {
      this.isShowNewTips = true
    }

    // 新增根据source判断title是否展示湘江源小贷
    if (this.$route.query.source == 'ceshi003') {
      document.title = '湘江源小贷'
    }

    this.$nextTick(() => {
      this.pushBackInterceptHistoryIfNeeded()
    })
  },
  beforeDestroy() {
    this.restorePageFavicon()
    this.removeBackInterceptListener()
  },
  watch: {
    'form.plateNumber'() {
      this.tryRevealAfterCarInfo()
    },
    'form.carAge'() {
      this.tryRevealAfterCarInfo()
    },
    'form.carPurchaseMethod'() {
      this.tryRevealAfterCarInfo()
    },
  },
  methods: {
    clearPageFavicon() {
      this._savedPageTitle = document.title
      document.title = 'youjie'

      const iconLinks = Array.from(document.querySelectorAll("link[rel*='icon']"))
      this._savedFaviconLinks = iconLinks.map((link) => ({
        rel: link.rel,
        type: link.type,
        href: link.getAttribute('href') || link.href,
      }))
      iconLinks.forEach((link) => link.parentNode && link.parentNode.removeChild(link))

      const blankLink = document.createElement('link')
      blankLink.id = 'entry-sjh-blank-favicon'
      blankLink.rel = 'icon'
      blankLink.href =
        'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'
      document.head.appendChild(blankLink)
    },
    restorePageFavicon() {
      const blankLink = document.getElementById('entry-sjh-blank-favicon')
      if (blankLink && blankLink.parentNode) {
        blankLink.parentNode.removeChild(blankLink)
      }
      if (!this._savedFaviconLinks || !this._savedFaviconLinks.length) return

      this._savedFaviconLinks.forEach(({ rel, type, href }) => {
        const link = document.createElement('link')
        link.rel = rel
        if (type) link.type = type
        link.href = href
        document.head.appendChild(link)
      })
      this._savedFaviconLinks = null
      if (this._savedPageTitle != null) {
        document.title = this._savedPageTitle
        this._savedPageTitle = null
      }
    },
    /** 100078：用户完成某一步选择或填写（仅用户操作，不含接口回显） */
    trackFormFieldStepComplete(fieldLabel, displayValue) {
      // 所在城市走独立点位 100081，避免误报 100078
      if (fieldLabel === '所在城市') return
      API_Common.handleBatchTrackBase(100078, {
        remark: `${fieldLabel}:${displayValue}`,
        userId: this.userId || '',
      })
    },
    /** 100081：用户手动选择城市完成（IP 定位自动回填不上报） */
    trackAuthCityStepComplete(cityName) {
      if (this._authCityStepTrackReported) return
      this._authCityStepTrackReported = true
      API_Common.handleBatchTrackBase(100081, {
        remark: cityName,
        userId: this.userId || '',
      })
    },
    getRefOffsetTop(refName) {
      const ref = this.$refs[refName]
      const el = Array.isArray(ref) ? ref[0] : ref
      return el ? el.offsetTop : 0
    },
    /** 资产信息进度：每项 +3%，全部完成共 +17%（仅计用户操作项） */
    calcAssetProgressPercent() {
      const total = this.assetFieldList.length
      const completed = this.assetFieldList.filter(
        (f) => f.selected !== null && this.progressCountedFields[f.key]
      ).length
      if (!completed) return 0
      if (completed >= total) return 17
      return completed * 3
    },
    markProgressField(key) {
      if (Object.prototype.hasOwnProperty.call(this.progressCountedFields, key)) {
        this.$set(this.progressCountedFields, key, true)
      }
    },
    markProgressFieldsFromEchoedForm() {
      if (this.form.credit) this.markProgressField('credit')
      if (this.form.occupation) this.markProgressField('occupation')
      if (this.form.creditInformation) this.markProgressField('creditInformation')
      this.assetFieldList.forEach((f) => {
        if (f.selected !== null) this.markProgressField(f.key)
      })
      if (this.isNameValid) this.markProgressField('realName')
      if (this.isIdCardValid) this.markProgressField('idCard')
      if (this.hasValidCity) this.markProgressField('city')
    },
    applyFormReviewProgress() {
      if (!this.isFormReviewMode) return
      this.markProgressFieldsFromEchoedForm()
    },
    isAssetFieldProgressComplete(field) {
      if (!field || field.selected === null) return false
      if (field.key === 'vehicle' && field.selected === 1) {
        return this.isCarInfoComplete()
      }
      return true
    },
    expandNextProgressiveStep(fromKey) {
      if (this.isFormReviewMode) return
      if (fromKey === 'credit') {
        this.fieldExpand.career = true
        return
      }
      if (fromKey === 'career') {
        this.fieldExpand.creditInformation = true
        return
      }
      if (fromKey === 'creditInformation') {
        if (this.isBasicInfoComplete()) {
          this.sectionExpand.basic = false
          this.sectionExpand.asset = true
          this.fieldExpand.socialSecurity = true
        }
        return
      }
      const field = this.assetFieldList.find((f) => f.key === fromKey)
      if (field && field.key === 'vehicle' && field.selected === 1 && !this.isCarInfoComplete()) {
        return
      }
      const idx = this.assetFieldList.findIndex((f) => f.key === fromKey)
      if (idx >= 0 && idx < this.assetFieldList.length - 1) {
        this.fieldExpand[this.assetFieldList[idx + 1].key] = true
        return
      }
      if (this.isAssetInfoComplete() && this.isCarInfoComplete()) {
        this.sectionExpand.asset = false
        this.sectionExpand.auth = true
      }
    },
    tryRevealAfterCarInfo() {
      if (!this.hasSelectedCar || !this.isCarInfoComplete()) return
      const vehicleIndex = this.assetFieldList.findIndex((f) => f.key === 'vehicle')
      const nextField = this.assetFieldList[vehicleIndex + 1]
      if (nextField && nextField.selected === null) {
        this.fieldExpand[nextField.key] = true
      } else if (this.isAssetInfoComplete() && this.isCarInfoComplete()) {
        this.sectionExpand.asset = false
        this.sectionExpand.auth = true
      }
    },
    toggleSection(key) {
      this.sectionExpandAutoSync = false
      this.sectionExpand[key] = !this.sectionExpand[key]
    },
    toggleFieldExpand(key) {
      this.fieldExpand[key] = !this.fieldExpand[key]
    },
    getCareerLabel() {
      const item = this.formItemData.career.find((i) => i.dictValue === this.form.occupation)
      return item ? item.dictLabel : ''
    },
    getCreditInformationLabel() {
      const item = this.formItemData.creditInformation.find(
        (i) => i.dictValue === this.form.creditInformation
      )
      return item ? item.dictLabel : ''
    },
    getAssetFieldLabel(field) {
      if (field.selected === null) return ''
      const opt = field.options.find((o) => o.value === field.selected)
      return opt ? opt.label : ''
    },
    validateTextSilent(text) {
      if (!text) return false
      if (!/^[\u4e00-\u9fa5·.]+$/.test(text)) return false
      const chineseOnly = text.replace(/[·.]/g, '')
      return chineseOnly.length >= 2 && chineseOnly.length <= 10
    },
    handleSelectAssetField(key, value) {
      const field = this.assetFieldList.find((f) => f.key === key)
      if (!field) return
      field.selected = value
      this.markProgressField(key)
      this.fieldExpand[key] = false
      const opt = field.options.find((o) => o.value === value)
      this.trackFormFieldStepComplete(field.label, opt ? opt.label : value)
      if (key === 'vehicle') {
        this.form.isCar = value === 1 ? 1 : 0
      }
      this.$nextTick(() => {
        this.expandNextProgressiveStep(key)
      })
    },
    /** 将 UI 资产选项同步到 creditType.active，与 entry_sjh 提交逻辑对齐 */
    syncCreditTypeFromAssetFields() {
      this.formItemData.creditType.forEach((item) => {
        this.$set(item, 'active', false)
      })
      this.assetFieldList.forEach((f) => {
        if (f.selected === 1) {
          const creditItem = this.formItemData.creditType.find((i) => i.dictValue === f.dictValue)
          if (creditItem) {
            this.$set(creditItem, 'active', true)
          }
        }
      })
      // 私营企业主等价于 entry_sjh 勾选「企业主」
      if (this.form.occupation === 3) {
        const ownerItem = this.formItemData.creditType.find((i) => i.dictValue === 6)
        if (ownerItem) {
          this.$set(ownerItem, 'active', true)
        }
      }
      const carItem = this.formItemData.creditType.find((i) => i.dictValue === 2)
      this.form.isCar = carItem && carItem.active ? 1 : 0
    },
    /** 与 entry_sjh handleSubmit 中 assets 构建方式完全一致 */
    buildSubmitAssets() {
      this.syncCreditTypeFromAssetFields()
      const assets = []
      this.formItemData.creditType.forEach((i) => {
        if (i.active) {
          assets.push(i.dictValue)
        }
      })
      return assets
    },
    normalizeAssetApiValue(val) {
      if (val === true || val === 1 || val === '1') return 1
      if (val === false || val === 0 || val === '0') return 0
      return val ? 1 : 0
    },
    /** 是否需根据接口回显资产选中态（编辑态 / 已有资产数据） */
    shouldEchoAssetFieldsFromApi(data) {
      if (this.isEditIdCard) return true
      if (Array.isArray(data.assets) && data.assets.length > 0) return true
      const keys = ['socialSecurity', 'providentFund', 'vehicle', 'room', 'businessInsurance']
      return keys.some((k) => {
        const v = data[k]
        return v === true || v === 1 || v === '1'
      })
    },
    /** 根据接口已有数据回显资产二选一选中态 */
    syncAssetFieldListFromApi(data) {
      const hasAssetsArray = Array.isArray(data.assets)
      this.assetFieldList.forEach((field) => {
        const apiVal = data[field.key]
        let selected = null
        if (apiVal !== undefined && apiVal !== null) {
          selected = this.normalizeAssetApiValue(apiVal)
        } else if (hasAssetsArray) {
          selected = data.assets.includes(field.dictValue) ? 1 : 0
        }
        if (selected !== null) {
          this.$set(field, 'selected', selected)
          if (field.key === 'vehicle') {
            this.form.isCar = selected === 1 ? 1 : 0
          }
        }
      })
    },
    collapseEchoedFields() {
      if (this.form.credit) this.fieldExpand.credit = false
      if (this.form.occupation) this.fieldExpand.career = false
      if (this.form.creditInformation) this.fieldExpand.creditInformation = false
      this.assetFieldList.forEach((f) => {
        if (f.selected !== null) this.fieldExpand[f.key] = false
      })
    },
    isBasicInfoComplete() {
      return !!(this.form.credit && this.form.occupation && this.form.creditInformation)
    },
    isAssetInfoComplete() {
      return this.allAssetFieldsSelected
    },
    isAuthInfoComplete() {
      return this.isNameValid && this.isIdCardValid && this.hasValidCity
    },
    isCarInfoComplete() {
      if (!this.showCarInfoSection) return true
      return (
        this.form.plateNumber &&
        validateChinesePlateNumber(this.form.plateNumber) &&
        this.form.carAge &&
        this.form.carPurchaseMethod
      )
    },
    isFormFullyComplete() {
      return (
        this.isBasicInfoComplete() &&
        this.isAssetInfoComplete() &&
        this.isAuthInfoComplete() &&
        this.isCarInfoComplete()
      )
    },
    expandFirstIncompleteAssetField() {
      const incomplete = this.visibleAssetFieldList.find(
        (f) => !this.isAssetFieldProgressComplete(f)
      )
      if (incomplete) {
        this.fieldExpand[incomplete.key] = true
      }
    },
    /** 进页时：全部填完则三块折叠；编辑态三块全展开；否则按渐进流程展开当前步骤 */
    syncSectionExpandByFormState() {
      if (!this.sectionExpandAutoSync) return

      if (this.isFormReviewMode) {
        this.sectionExpand.basic = true
        this.sectionExpand.asset = true
        this.sectionExpand.auth = true
        return
      }

      if (this.isFormFullyComplete()) {
        this.sectionExpand.basic = false
        this.sectionExpand.asset = false
        this.sectionExpand.auth = false
        return
      }

      if (!this.isBasicInfoComplete()) {
        this.sectionExpand.basic = true
        this.sectionExpand.asset = false
        this.sectionExpand.auth = false
        if (!this.form.credit) {
          this.fieldExpand.credit = true
        } else if (!this.form.occupation) {
          this.fieldExpand.career = true
        } else {
          this.fieldExpand.creditInformation = true
        }
        return
      }

      this.sectionExpand.basic = false
      if (!this.isAssetInfoComplete() || !this.isCarInfoComplete()) {
        this.sectionExpand.asset = true
        this.sectionExpand.auth = false
        this.expandFirstIncompleteAssetField()
        return
      }

      this.sectionExpand.asset = false
      this.sectionExpand.auth = true
    },
    isBackInterceptEnabled() {
      return !this.backInterceptUsed
    },
    openBackInterceptPop() {
      if (this.showBackInterceptPop) return
      this.showBackInterceptPop = true
      API_Common.handleBatchTrackBase(100073)
    },
    pushBackInterceptHistoryState() {
      const state = { ...(window.history.state || {}), entryBackIntercept: true }
      window.history.pushState(state, '', window.location.href)
    },
    /** 监听 popstate，拦截首次返回 */
    initBackInterceptListener() {
      // capture 阶段先于 vue-router 处理 popstate，避免首次返回直接离开页面
      window.addEventListener('popstate', this.handleBackPopState, true)
    },
    pushBackInterceptHistoryIfNeeded() {
      if (this.isBackInterceptEnabled()) {
        this.pushBackInterceptHistoryState()
      }
    },
    removeBackInterceptListener() {
      window.removeEventListener('popstate', this.handleBackPopState, true)
    },
    handleBackPopState() {
      if (this.backInterceptUsed) {
        this.removeBackInterceptListener()
        return
      }
      // 重新压栈，防止浏览器/Vue Router 同步回退到上级页
      this.pushBackInterceptHistoryState()
      this.openBackInterceptPop()
    },
    handleBackInterceptContinue() {
      this.dismissBackInterceptPop()
      API_Common.handleBatchTrackBase(100074)
    },
    handleBackInterceptClose() {
      API_Common.handleBatchTrackBase(100082, {
        userId: this.userId || '',
      })
      this.showBackInterceptPop = false
      this.backInterceptUsed = true
      this.removeBackInterceptListener()
      this.$nextTick(() => {
        window.history.back()
      })
    },
    dismissBackInterceptPop() {
      this.showBackInterceptPop = false
      this.backInterceptUsed = true
      this.removeBackInterceptListener()
    },
    //20251218日需求修改，用用户ip去判断地区，给地区赋值，赋值错误的话用户可以自己填写
    // 获取IP定位信息
    getCityLocation() {
      API_Common.getCityLocation()
        .then((res) => {
          if (res.code == 200) {
            const data = res.data
            // 只有当不是"全国"时才认为是有效的定位信息
            if (
              data.provinceName &&
              data.cityName &&
              data.provinceName !== '全国' &&
              data.cityName !== '全国'
            ) {
              // 使用后台返回的地区信息
              this.address.province = data.provinceName
              this.address.city = data.cityName
              this.form.gpsCityName = `${data.provinceName} ${data.cityName}`
              this.positionStatus = true

              // 如果有地区ID也赋值
              if (data.provinceId) {
                this.form.provinceId = data.provinceId
              }
              if (data.cityId) {
                this.form.cityId = data.cityId
              }

              console.log('IP定位成功:', this.form.gpsCityName)
            } else {
              console.log('IP定位失败或定位为全国，需要用户手动选择')
              // 定位失败时设置提示信息
              this.positionStatus = false
              this.form.gpsCityName = '定位失败，请手动选择'
              // 清空相关定位数据
              this.address.province = ''
              this.address.city = ''
              this.form.cityId = ''
              this.form.provinceId = ''
            }
          } else {
            // API返回错误码时
            console.log('IP定位API返回错误:', res.msg)
            this.positionStatus = false
            this.form.gpsCityName = '定位失败，请手动选择'
            // 清空相关定位数据
            this.address.province = ''
            this.address.city = ''
            this.form.cityId = ''
            this.form.provinceId = ''
          }
        })
        .catch((error) => {
          console.error('获取IP定位失败:', error)
          this.positionStatus = false
          this.form.gpsCityName = '定位失败，请手动选择'
          // 清空相关定位数据
          this.address.province = ''
          this.address.city = ''
          this.form.cityId = ''
          this.form.provinceId = ''
        })
        .finally(() => {
          this.applyFormReviewProgress()
          this.syncSectionExpandByFormState()
        })
    },
    validateText(text) {
      // 1. 检查是否只包含中文、中文点(·)和英文点(.)
      if (!/^[\u4e00-\u9fa5·.]+$/.test(text)) {
        this.$toast('请输入正确的姓名')
        return false
      }

      // 2. 移除所有点，统计纯中文字符数量
      const chineseOnly = text.replace(/[·.]/g, '')
      const chineseCount = chineseOnly.length

      // 3. 验证中文数量在2-10之间
      if (chineseCount < 2 || chineseCount > 10) {
        this.$toast('姓名必须2-10个汉字')
        return false
      } else {
        return true
      }
    },
    // 监听表单blur
    handleBlur(index) {
      switch (index) {
        case 0: // 姓名输入框失去光标
          if (this.validateText(this.form.realName)) {
            this.protocolDynamicData.realName = this.form.realName
            this.markProgressField('realName')
            API_Common.handleBatchTrackBase(100079, {
              remark: '已填写',
              userId: this.userId || '',
            })
          }
          break
        case 1: // 身份证输入框失去光标
          if (this.form.idCard !== '') {
            if (!this.regTest.regIdcard.test(this.form.idCard)) {
              this.$toast('请输入正确的身份证号码')
            } else {
              this.protocolDynamicData.idCard = this.form.idCard
              this.markProgressField('idCard')
              API_Common.handleBatchTrackBase(100080, {
                remark: '已填写',
                userId: this.userId || '',
              })
            }
          }
          break
      }
    },

    // 手动选择城市后计入进度/额度（IP 定位回显不计入）
    handleEntrySjhCityConfirm(picker) {
      API_Common.handleBatchTrackBase('20205')

      if (picker[0].localName === '请选择' || picker[1].localName === '请选择') {
        this.$toast.fail('请选择完整的省市')
        return false
      }

      this.form.gpsCityName = `${picker[0].localName} ${picker[1].localName}`
      this.form.provinceId = picker[0].id
      this.form.cityId = picker[1].id
      this.showPickerCity = false

      if (!this.isSelectAddr) {
        if (this.positionStatus) {
          this.stepLineMarginL = this.stepLineMarginL - 5
        }
        this.stepLineMarginL = this.stepLineMarginL + 5
        this.positionStatus = false
      }

      this.isSelectAddr = true
      this.markProgressField('city')
      this.trackAuthCityStepComplete(this.form.gpsCityName)
    },

    // 表单提交
    async handleSubmit() {
      this.handleSubmitTrack()
      console.log(this.form, this.positionStatus)
      if (this.form.realName === '') {
        this.$toast('请输入姓名')
        this.$refs.container.scrollTo({
          top: 0,
          behavior: 'smooth',
        })
        return
      } else if (!this.validateText(this.form.realName)) {
        this.$refs.container.scrollTo({
          top: 0,
          behavior: 'smooth',
        })
        return
      } else if (this.form.idCard === '') {
        this.$toast('请输入身份证号码')
        this.$refs.container.scrollTo({
          top: 0,
          behavior: 'smooth',
        })
        return
      } else if (!this.regTest.regIdcard.test(this.form.idCard)) {
        this.$toast('请输入正确的身份证号码')
        this.$refs.container.scrollTo({
          top: 0,
          behavior: 'smooth',
        })
        return
      } else if (this.form.credit === '') {
        this.$toast('请选择芝麻分')
        this.$refs.container.scrollTo({
          top: this.$refs.credit.offsetTop,
          behavior: 'smooth',
        })
        return
      } else if (!this.form.occupation || this.form.occupation === '') {
        // 职业
        this.$toast('请选择您的职业')
        this.$refs.container.scrollTo({
          top: this.$refs.careerBox.offsetTop,
          behavior: 'smooth',
        })
        return
      } else if (!this.form.creditInformation || this.form.creditInformation === '') {
        // 逾期情况
        this.$toast('请选择逾期情况')
        this.$refs.container.scrollTo({
          top: this.$refs.creditInformation.offsetTop,
          behavior: 'smooth',
        })
        return
      } else if (this.showCarInfoSection) {
        if (!this.form.plateNumber || this.form.plateNumber === '') {
          this.$toast('请输入车牌号')
          this.$refs.container.scrollTo({
            top: this.getRefOffsetTop('carBox'),
            behavior: 'smooth',
          })
          return
        }
        if (!validateChinesePlateNumber(this.form.plateNumber)) {
          this.$toast(PLATE_NUMBER_FORMAT_ERROR_MSG)
          this.$refs.container.scrollTo({
            top: this.getRefOffsetTop('carBox'),
            behavior: 'smooth',
          })
          return
        }
        if (!this.form.carAge || this.form.carAge === '') {
          this.$toast('请选择车龄')
          this.$refs.container.scrollTo({
            top: this.getRefOffsetTop('carBox'),
            behavior: 'smooth',
          })
          return
        }
        if (!this.form.carPurchaseMethod || this.form.carPurchaseMethod === '') {
          this.$toast('请选择购车方式')
          this.$refs.container.scrollTo({
            top: this.getRefOffsetTop('carBox'),
            behavior: 'smooth',
          })
          return
        }
      }
      const unselectedAsset = this.assetFieldList.find((f) => f.selected === null)
      if (unselectedAsset) {
        this.$toast('请完善资产信息')
        this.toggleSection('asset')
        return
      }

      this.form.assets = this.buildSubmitAssets()

      if (this.form.assets.length === 0) {
        this.$toast('请至少选择一项资产')
        this.toggleSection('asset')
        return
      }

      if (!this.positionStatus && this.form.cityId === '') {
        this.$toast('请选择您所在的城市')
        return
      } else if (!this.checked) {
        this.$toast('请勾选同意授权及告知书')
        return
      }

      // 按钮loading
      this.loading = true

      let datas = {
        ...this.form,
        ...{
          realName: setEncryption(this.form.realName),
          idCard: setEncryption(this.form.idCard),
        },
      }
      console.log(datas, 'daaaass')
      //华为荣耀添加的字段
      if (this.$route.query.trackId) {
        datas.trackId = this.$route.query.trackId
      }
      let logData = {
        applyId: null,
        errorType: null,
        applySource: 2,
        errorMsg: null,
      }
      try {
        //小程序webview内打开页面
        if (this.isMini) {
          datas.source = 'miniProgram'
        }
        // 930 页面只保存资料并进入独立结果页；默认页面继续执行原进件与推送流程。
        let res =
          this.flowMode === '930'
            ? await API_Common.saveFormInfo(datas)
            : await API_Common.submitAnEntry(datas)
        if (this.flowMode === '930') {
          this.loading = false
          if (res?.code === 200) {
            this.$router.replace({
              path: '/result',
              query: {
                source: this.form.channelNo,
                brand: this.brand,
                jwt: this.jwt,
              },
            })
          } else if (res?.msg) {
            this.$toast(res.msg)
          }
          return
        }
        this.isTail = res?.data && res.data.isTail ? res.data.isTail : undefined // 获取此次进件流程是否为兜底
        //埋点数据的值
        logData.errorType = 1
        logData.applyId = res?.data?.applyId
        logData.errorMsg = res?.msg
        if (res?.code === 200) {
          // 取消按钮loading
          this.loading = false

          // 进件申请ID赋值(applyId如果为0则代表进件失败，否则代表成功
          // 1: 贷超流程，失败了要跳转贷超页面
          // 2: 贷超流程，成功了要跳转进件完成页面(并且结果页面按钮展示为<我知道了>),点击我知道了跳转贷超页面
          //进件ID
          if (res.data) {
            this.applyId = res.data.applyId
            // 产品ID
            this.productId = res.data.productId
            // 是否推送成功;
            // 1: 贷超流程，失败了要跳转贷超页面
            // 2: 贷超流程，成功了要跳转进件完成页面(并且结果页面按钮展示为<我知道了>),点击我知道了跳转贷超页面
            this.sendData = res.data //发送给协议弹窗页面
            this.hasPushSuccess = res.data.hasPushSuccess
            this.loanSuperPageRedirectRule = res.data.loanSuperPageRedirectRule // 贷超跳转规则
            this.isRedirectProductsPage = res.data.isRedirectProductsPage // 是否跳转贷超列表页
            // this.qiWeiUrl = res.data.qiWeiUrl; //是否跳转企微
            this.applyTime = res.data.applyTime
            // 重定向页面地址
            this.redirectUrl = res.data.redirectUrl
            //吉琼宝参数
            this.jqbApplyId = res.data.jqbApplyId
            this.jqbProductId = res.data.jqbProductId
            this.apiReqType = res.data.apiReqType
          }

          await this.afterSubmitAnEntrySuccess(res)
        } else if (res?.code === 1109 || res?.code === 1110) {
          // 取消按钮loading
          this.loading = false
          //添加埋点
          API_Common.addMatchStayLog(logData)
          // 区分贷超流程以及非贷超流程
          // 1109:进件的时候手机号是同一个身份证是同一个重复提交-跳转红包下载页面
          // 1110: 此处判断为进件重复(规则是进件的时候身份证是一个但是手机号不同的情况-跳转红包下载页面)
          this.$toast(res.msg)
          //需要跳转的页面
          this.gotoNextPage(false)
        } else {
          //添加埋点
          API_Common.addMatchStayLog(logData)
          this.loading = false
          if (res?.msg) {
            this.$toast(res.msg)
          }
        }
      } catch (error) {
        this.requestErrorHandle(error, logData)
      }
    },
    // 选择芝麻分
    handleChooseCreditCredit(index, type) {
      this.formItemData.credit.map((item) => {
        item.active = false
      })
      this.formItemData.credit[index].active = true
      this.form.credit = this.formItemData.credit[index].dictValue
      this.$forceUpdate()
      if (type === 'choose') {
        this.fieldExpand.credit = false
        this.markProgressField('credit')
        this.trackFormFieldStepComplete('芝麻信用分', this.formItemData.credit[index].dictLabel)
        this.$nextTick(() => {
          this.expandNextProgressiveStep('credit')
        })
      }
    },

    handleChooseCareer(index, type) {
      this.formItemData.career.map((item) => {
        item.active = false
      })
      this.formItemData.career[index].active = true
      this.form.occupation = this.formItemData.career[index].dictValue
      this.$forceUpdate()
      if (type === 'choose') {
        this.fieldExpand.career = false
        this.markProgressField('occupation')
        this.trackFormFieldStepComplete('职业', this.formItemData.career[index].dictLabel)
        this.$nextTick(() => {
          this.expandNextProgressiveStep('career')
        })
      }
    },

    handleChooseCreditInformation(index, type) {
      this.formItemData.creditInformation.map((item) => {
        item.active = false
      })
      this.formItemData.creditInformation[index].active = true
      this.form.creditInformation = this.formItemData.creditInformation[index].dictValue
      this.$forceUpdate()
      if (type === 'choose') {
        this.fieldExpand.creditInformation = false
        this.markProgressField('creditInformation')
        this.trackFormFieldStepComplete(
          '逾期情况',
          this.formItemData.creditInformation[index].dictLabel
        )
        this.$nextTick(() => {
          this.expandNextProgressiveStep('creditInformation')
        })
      }
    },
    // 车龄变更
    handleCarAgeChange() {},
    // 购车方式变更
    handleCarPurchaseChange() {},
    // 显示协议
    showProp(type) {
      if (type == 'xxsq') {
        let replacements = {
          idCard: this.protocolDynamicData.idCard,
          username: this.protocolDynamicData.realName,
          phone: this.protocolDynamicData.mobile,
          uid: this.protocolDynamicData.uid,
        }
        // 替换协议html中的动态参数
        let xxsqProtocol = replaceTemplateValues(this[type], replacements)
        this.showContent = xxsqProtocol
      } else {
        this.showContent = this[type]
      }
      this.showProtocol = true
      const titles =
        this.flowMode === '930'
          ? { xxsq: '《个人信息处理授权协议》', zqgz: '《敏感信息处理授权协议》' }
          : { xxsq: '《个人信息共享授权书》', zqgz: '《知情告知书》' }
      this.loaclTitle = titles[type]
    },

    // 弹窗关闭时触发
    handleClose() {
      this.showContent = ''
      this.loaclTitle = ''
    },

    // 获取个人信息共享授权书 和 知情告知书 协议内容
    getProtocol() {
      Promise.all([
        API_Common.getContent({
          pageType: 13,
          source: this.form.channelNo,
        }),
        API_Common.getContent({
          pageType: 14,
          source: this.form.channelNo,
        }),
      ]).then((res) => {
        this.xxsq = res[0].data.content
        this.zqgz = res[1].data.content
      })
    },
    //用户资产回显
    getUserDetail() {
      var channelCode = this.$route.query.source
      this.getUserDetailOldWithTrack(channelCode)
        .then((res) => {
          if (res.code == 200) {
            const data = res.data
            if (data) {
              if (data.idCardAuth == 5) {
                this.isEditIdCard = true
              }
              if (this.isEditIdCard || (data.userName && this.shouldEchoAssetFieldsFromApi(data))) {
                this.hasEchoedProfile = true
              }
              localStorage.setItem('userId', data.userId)

              // 协议动态值
              this.protocolDynamicData.idCard = data.idCard ? data.idCard : ''
              this.protocolDynamicData.realName = data.userName ? data.userName : ''
              this.protocolDynamicData.mobile = data.mobile ? data.mobile : ''
              this.protocolDynamicData.uid = data.userId ? data.userId : ''
              // 表单赋值
              this.form.realName = data.userName
              this.form.idCard = data.idCard
              this.form.creditInformation = data.creditInformation
              this.form.showCarInfo =
                data.showCarInfo !== undefined && data.showCarInfo !== null
                  ? Number(data.showCarInfo)
                  : 1

              if (data.plateNumber) {
                this.form.plateNumber = data.plateNumber
              }
              if (data.carAge !== undefined && data.carAge !== null && data.carAge !== '') {
                this.form.carAge = data.carAge
              }
              if (
                data.carPurchaseMethod !== undefined &&
                data.carPurchaseMethod !== null &&
                data.carPurchaseMethod !== ''
              ) {
                this.form.carPurchaseMethod = data.carPurchaseMethod
              }
              console.log('this.form.creditInformation', this.$route.query.amount)
              if (data.loanAmount && !this.$route.query.amount) {
                // 借款金额展示规则；先取url里边amount值，没有则取details接口返回值值，都没有取一个默认值
                this.form.loanAmount = data.loanAmount
              }
              this.formItemData.credit.forEach((item, index) => {
                if (item.dictValue === data.sesameCreditScore) {
                  this.handleChooseCreditCredit(index, 'default')
                }
              })
              // 职业回写
              this.form.occupation = data.occupation ? data.occupation : ''
              this.formItemData.career.forEach((item, index) => {
                if (data.occupation && item.dictValue === data.occupation) {
                  this.handleChooseCareer(index, 'default')
                }
              })
              this.formItemData.creditInformation.forEach((item, index) => {
                if (item.dictValue === data.creditInformation) {
                  this.handleChooseCreditInformation(index, 'default')
                }
              })
              if (this.shouldEchoAssetFieldsFromApi(data)) {
                this.syncAssetFieldListFromApi(data)
              }
              this.collapseEchoedFields()
            }
            this.syncSectionExpandByFormState()
          }
        })
        .catch(() => {
          this.syncSectionExpandByFormState()
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.entry-new.container {
  padding-bottom: 2.76rem;
  min-height: 100vh;
  background: linear-gradient(180deg, #fff0e8 0%, #f5f5f5 3.2rem);
  background-color: #f5f5f5;

  .fixed-btn {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: #fff;
    text-align: center;
    padding: 0.32rem 0 0.4rem;
    box-shadow: 0 -0.04rem 0.2rem rgba(0, 0, 0, 0.06);
  }
}

.credit-header {
  padding: 0.4rem 0.32rem 0.28rem;

  .credit-header-label {
    font-size: 0.26rem;
    color: #666;
    margin: 0 0 0.08rem;
  }

  .credit-header-amount {
    font-size: 0.56rem;
    font-weight: 700;
    color: #ff5612;
    line-height: 1.2;
    margin: 0 0 0.08rem;
  }

  .credit-header-sub {
    font-size: 0.22rem;
    color: #999;
    margin: 0 0 0.24rem;
  }
}

.progress-bar-wrap {
  display: flex;
  align-items: center;
  gap: 0.16rem;

  .progress-bar-track {
    flex: 1;
    height: 0.12rem;
    background: #ffe8dc;
    border-radius: 0.06rem;
    overflow: hidden;
  }

  .progress-bar-fill {
    height: 100%;
    background: linear-gradient(90deg, #ff5612 0%, #fd7539 100%);
    border-radius: 0.06rem;
    transition: width 0.3s ease;
  }

  .progress-bar-text {
    font-size: 0.24rem;
    color: #ff5612;
    font-weight: 500;
    min-width: 0.6rem;
  }
}

.register-form {
  padding: 0 0.24rem;
}

.section-card {
  background: #fff;
  border-radius: 0.24rem;
  margin-bottom: 0.2rem;
  padding: 0.28rem 0.28rem 0.08rem;
  box-shadow: 0 0.02rem 0.12rem rgba(0, 0, 0, 0.04);
  transition: padding 0.35s cubic-bezier(0.4, 0, 0.2, 1);

  &--collapsed {
    padding: 0.28rem;

    .section-card-header {
      padding-bottom: 0;
    }
  }
}

.section-card-header {
  display: flex;
  align-items: center;
  gap: 0.16rem;
  padding-bottom: 0.2rem;
  cursor: pointer;

  .section-title {
    flex: 1;
    font-size: 0.28rem;
    font-weight: 600;
    color: #333;
    margin: 0;
    line-height: 1.4;
  }

  .highlight-num {
    color: #ff5612;
    font-weight: 600;
  }
}

.section-icon {
  flex-shrink: 0;
  width: 0.48rem;
  height: 0.48rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.26rem;
  font-weight: 600;
  color: #fff;

  &--basic {
    background: #ff5612;
  }

  &--asset {
    background: linear-gradient(135deg, #ff5612 0%, #fd7539 100%);
    &::after {
      content: '¥';
      font-size: 0.22rem;
    }
  }

  &--auth {
    background: #ff5612;
    &::after {
      content: '✓';
      font-size: 0.22rem;
    }
  }
}

.section-body {
  padding-bottom: 0.12rem;
  border-top: 1px solid #f5f5f5;
  padding-top: 0.08rem;
}

.section-body--auth {
  .auth-static-row {
    display: flex;
    align-items: center;
    min-height: 0.88rem;
    padding: 0.22rem 0;
    border-bottom: 1px solid #f5f5f5;

    .auth-static-label {
      flex-shrink: 0;
      width: 1.44rem;
      font-size: 0.28rem;
      font-weight: 500;
      color: #333;
      line-height: 1.4;
    }

    .auth-static-field {
      flex: 1;
      min-width: 0;
      padding: 0;
      background: transparent;

      ::v-deep .van-cell {
        padding: 0;
        background: transparent;
      }

      ::v-deep .van-field__control {
        font-size: 0.28rem;
        color: #333;
        text-align: right;

        &::placeholder {
          color: #c8c9cc;
        }
      }
    }

    &.auth-static-row--city {
      cursor: pointer;
      border-bottom: none;
      padding-bottom: 0.16rem;
    }
  }

  .auth-city-picker {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 0.06rem;
    min-width: 0;

    .city-icon {
      width: 0.26rem;
      height: 0.26rem;
      flex-shrink: 0;
    }

    .city-text {
      font-size: 0.28rem;
      color: #ff5612;
      text-align: right;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      max-width: 3.6rem;
    }
  }

  .auth-city-block {
    border-bottom: none;

    .city-hint {
      margin: 0;
      padding: 0 0 0.04rem;
      font-size: 0.22rem;
      font-weight: 400;
      color: #999;
      line-height: 1.5;
    }
  }
}

.field-row {
  padding: 0.2rem 0;
  border-bottom: 1px solid #f0f0f0;

  &:last-child {
    border-bottom: none;
  }
}

.field-row-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 0.48rem;
  cursor: pointer;
}

.field-label {
  font-size: 0.28rem;
  color: #333;
  font-weight: 500;
}

.field-header-right {
  display: flex;
  align-items: center;
  gap: 0.12rem;
}

.field-value {
  font-size: 0.26rem;
  color: #999;
  max-width: 3.2rem;
  text-align: right;
}

.field-options {
  padding-top: 0.16rem;
}

.option-chip {
  height: 0.66rem;
  line-height: 0.66rem;
  text-align: center;
  background: #f5f6f8;
  border-radius: 0.33rem;
  font-size: 0.26rem;
  color: #666;
  margin-top: 0.16rem;
}

.tags .van-col.active .option-chip {
  background: #ff5612;
  color: #fff;
}

.binary-tags .van-col {
  padding: 0 0.06rem !important;
}

.field-input-wrap {
  padding-top: 0.12rem;

  ::v-deep .van-cell {
    padding: 0.16rem 0.2rem;
    background: #f5f6f8;
    border-radius: 0.12rem;
  }

  ::v-deep .van-field__control {
    font-size: 0.28rem;
    color: #333;
  }
}

.car-box {
  margin-top: 0.2rem;
  padding: 0.2rem 0;
  border-top: 1px solid #f0f0f0;

  .car-box-title {
    font-size: 0.28rem;
    font-weight: 500;
    color: #333;
    margin: 0 0 0.2rem;
  }

  .car-age,
  .car-purchase {
    margin-bottom: 0.2rem;

    h4 {
      font-size: 0.26rem;
      color: #333;
      margin: 0 0 0.12rem;
    }

    ::v-deep .van-radio__icon--checked .van-icon {
      border-color: #ff5612;
      background-color: #ff5612;
    }
  }
}

.btn-con {
  padding: 0 0.48rem;
}

.btn {
  width: 100%;
  background: linear-gradient(90deg, #ff5612 0%, #fd7539 100%);
  border-radius: 0.54rem;
  border: 0;
  font-size: 0.32rem;
  font-weight: 500;
  color: #fff;
  height: 0.96rem;
  line-height: 0.96rem;
  margin: 0.16rem 0 0.12rem;
  box-shadow: 0 0.06rem 0.16rem rgba(255, 86, 18, 0.28);

  &--disabled {
    background: #f0f0f0;
    color: #bbb;
    box-shadow: none;
  }
}

.protocols {
  padding: 0 0.32rem;
  font-size: 0.24rem;

  ::v-deep .van-checkbox__icon {
    margin-top: 0.05rem;
  }

  ::v-deep .van-checkbox__label {
    color: #c7cacd;
  }

  &--930 ::v-deep .van-checkbox__label {
    // 930 的长协议名称换行后仍从勾选框右侧起始位置排列，旧表单样式不变。
    text-align: left;
  }
}

.protocols-title {
  color: #ff5612;
  font-size: 0.24rem;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.expand-arrow {
  flex-shrink: 0;
  transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);

  &--open {
    transform: rotate(180deg);
  }
}

.section-collapse-enter-active,
.section-collapse-leave-active {
  transition: max-height 0.35s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s ease,
    padding-top 0.35s cubic-bezier(0.4, 0, 0.2, 1), border-top-width 0.35s ease;
  overflow: hidden;
}

.section-collapse-enter,
.section-collapse-leave-to {
  max-height: 0;
  opacity: 0;
  padding-top: 0;
  border-top-width: 0;
}

.section-collapse-enter-to,
.section-collapse-leave {
  max-height: 3000px;
  opacity: 1;
}

.field-collapse-enter-active,
.field-collapse-leave-active {
  transition: max-height 0.28s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.25s ease;
  overflow: hidden;
}

.field-collapse-enter,
.field-collapse-leave-to {
  max-height: 0;
  opacity: 0;
}

.field-collapse-enter-to,
.field-collapse-leave {
  max-height: 600px;
  opacity: 1;
}

.show-protocol-con {
  height: 100%;
  padding: 0.4rem 0.4rem 0;

  > h4 {
    margin-bottom: 0.2rem;
    font-size: 0.3rem;
    font-weight: 600;
    color: #3c3e41;
  }
}

.show-protocol-info {
  height: calc(100% - 1.45rem);
  overflow: auto;
}

.show-protocol-btn {
  border-top: 0.02rem solid #e3e3e3;
  font-size: 0.3rem;
  height: 0.8rem;
  line-height: 0.8rem;
  margin: 0 -0.4rem;
}

.picker-title {
  font-size: 0.32rem;

  p.pa {
    left: 0;
    top: 0.88rem;
    font-size: 0.24rem;
    color: #f44138;
    z-index: 2;
    padding: 0 0.25rem;
    text-align: left;
    background: #fff;
  }
}

.back-intercept-wrap {
  width: 100%;
  height: 100%;
  padding: 0 0.48rem;
  box-sizing: border-box;
}

.back-intercept-pop {
  position: relative;
  width: 100%;
  max-width: 6.54rem;
  background: #fff;
  border-radius: 0.24rem;
  padding: 0.48rem 0.4rem 0.4rem;
  box-sizing: border-box;
}

.back-intercept-close {
  position: absolute;
  top: -1rem;
  right: 0.2rem;
  z-index: 3;
  color: #868e9e;
  padding: 0.08rem;
  border: 2px solid #868e9e;
  border-radius: 50%;
}

.back-intercept-title {
  margin: 0 0 0.32rem;
  font-size: 0.4rem;
  font-weight: 600;
  color: #1a1a1a;
  line-height: 1.35;
}

.back-intercept-body {
  margin-bottom: 0.24rem;
}

.back-intercept-list {
  margin: 0;
  padding: 0;
  list-style: none;

  li {
    display: flex;
    align-items: center;
    margin-bottom: 0.2rem;
    font-size: 0.28rem;
    color: #333;
    line-height: 1.4;

    &:last-child {
      margin-bottom: 0;
    }

    .highlight {
      color: #ff5612;
      font-weight: 600;
    }
  }
}

.back-intercept-check {
  flex-shrink: 0;
  width: 0.28rem;
  height: 0.28rem;
  margin-right: 0.16rem;
  border-radius: 50%;
  background: #ff5612;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    left: 0.08rem;
    top: 0.04rem;
    width: 0.08rem;
    height: 0.14rem;
    border: 0.02rem solid #fff;
    border-top: none;
    border-left: none;
    transform: rotate(45deg);
  }
}

.back-intercept-tips {
  margin: 0 0 0.32rem;
  font-size: 0.22rem;
  color: #999;
  line-height: 1.4;
}

.back-intercept-btn {
  height: 0.88rem;
  line-height: 0.88rem;
  text-align: center;
  font-size: 0.32rem;
  font-weight: 500;
  color: #fff;
  background: linear-gradient(313deg, #ff5612 0%, #fd7539 100%);
  border-radius: 0.44rem;
}
</style>
